<template>
  <v-dialog
    :value="value"
    :content-class="dialogContentClass"
    :max-width="mobile ? undefined : 760"
    transition="dialog-bottom-transition"
    overlay-color="#193153"
    overlay-opacity="0.35"
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card flat class="va-panel" :class="{ 'va-panel-sheet': mobile }">
      <v-card-title class="va-panel-header">
        <div class="va-panel-heading">
          <h2 class="va-panel-title">{{ title }}</h2>
          <p v-if="subtitle" class="va-panel-subtitle">{{ subtitle }}</p>
        </div>
        <v-btn icon aria-label="Fechar" class="va-panel-close" @click="close">
          <v-icon size="20" color="primary">{{ mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="va-panel-body">
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
/* `vetalfa.css` força max-height 100% !important em todo dialog. Aqui a regra
   é mais específica e também !important, para o painel caber na viewport e o
   corpo poder rolar (padrão `scrollable` do app: card fixo, v-card-text rola). */
.v-dialog.va-panel-dialog:not(.v-dialog--fullscreen) {
  max-height: 90% !important;
}

.v-dialog.va-panel-dialog.v-bottom-sheet:not(.v-dialog--fullscreen) {
  max-height: 85% !important;
}

.va-panel {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 16px !important;
}

.va-panel-sheet {
  border-radius: 24px 24px 0 0 !important;
}

.va-panel-header.v-card__title {
  display: flex;
  flex: none;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 22px 20px 12px;
  word-break: normal;
}

.va-panel-sheet .va-panel-header.v-card__title {
  padding: 20px 16px 12px;
}

.va-panel-heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.va-panel-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #193153;
}

.va-panel-subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  color: #6b7a90;
}

.va-panel-close {
  margin: -4px -8px 0 0;
}

.va-panel-body.v-card__text {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 20px 22px;
  color: #193153;
  font-size: 14px;
}

.va-panel-sheet .va-panel-body.v-card__text {
  padding: 4px 16px 24px;
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
  padding-bottom: calc(24px + constant(safe-area-inset-bottom));
}
</style>

<script>
import { mdiClose } from "@mdi/js";

export default {
  name: "VetalfaPanel",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
  },
  computed: {
    mobile() {
      return this._isMobile();
    },
    dialogContentClass() {
      return this.mobile ? "va-panel-dialog v-bottom-sheet" : "va-panel-dialog";
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    /**
     * No Android o botão voltar fecha o painel aberto. O listener só existe
     * enquanto o painel está visível, para não interferir na navegação normal.
     */
    onBackButton(event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      this.close();
    },
    bindBackButton() {
      if (this.backButtonBound || !this._isCordovaApp()) return;
      document.addEventListener("backbutton", this.onBackButton, false);
      this.backButtonBound = true;
    },
    unbindBackButton() {
      if (!this.backButtonBound) return;
      document.removeEventListener("backbutton", this.onBackButton, false);
      this.backButtonBound = false;
    },
  },
  watch: {
    value: {
      handler(open) {
        if (open) {
          this.bindBackButton();
        } else {
          this.unbindBackButton();
        }
      },
      immediate: true,
    },
    "$route.path"() {
      if (this.value) {
        this.close();
      }
    },
  },
  beforeDestroy() {
    this.unbindBackButton();
  },
  data() {
    return {
      mdiClose,
      backButtonBound: false,
    };
  },
};
</script>
